import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { investorApi } from '@/api';
import { userActions } from '@/store/user';

export const useReferralToken = ({
  paramId,
  referralToken,
  referralView,
  referralId,
  onError,
  onSuccess
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (paramId && !referralToken && referralView && referralId) {
      (async () => {
        try {
          const res = await investorApi.getReferralToken(referralId);

          if (res) {
            dispatch(userActions.setReferralToken(res.data.accessToken));
            if (onSuccess) {
              onSuccess();
            }
          }
        } catch (e) {
          if (onError) {
            onError(e.response?.data?.message || e.message);
          }
        }
      })();
    }
  }, [paramId, referralToken, referralId, referralView, dispatch, onError, onSuccess]);
};
